<div class="user-modal">
    <div class="user-modal__header">
        <h3>{{ title }}</h3>
        <button type="button" class="user-modal__close" (click)="activeModal.dismiss()" [attr.aria-label]="'admin_action_close' | translate">&times;</button>
    </div>

    <form class="user-modal__body" (ngSubmit)="save()">
        <label class="field">
            <span>{{ 'field_username' | translate }}</span>
            <input ngbAutofocus type="text" name="username" [(ngModel)]="username" autocomplete="off"
                [class.invalid]="usernameInvalid" [class.shake]="shaking && usernameInvalid" />
        </label>

        <div class="field-row">
            <label class="field">
                <span>{{ 'field_password' | translate }}</span>
                <input type="password" name="password" [(ngModel)]="password" autocomplete="new-password"
                    [placeholder]="id ? ('user_modal_password_keep' | translate) : ''"
                    [class.invalid]="passwordInvalid" [class.shake]="shaking && passwordInvalid" />
            </label>
            <label class="field">
                <span>{{ 'field_confirm_password' | translate }}</span>
                <input type="password" name="confirmPassword" [(ngModel)]="confirmPassword" autocomplete="new-password"
                    [class.invalid]="passwordInvalid" [class.shake]="shaking && passwordInvalid" />
            </label>
        </div>

        <label class="field">
            <span>{{ 'field_name' | translate }}</span>
            <input type="text" name="name" [(ngModel)]="name" autocomplete="off" />
        </label>

        <div class="field-row">
            <label class="field">
                <span>{{ 'field_mobile' | translate }}</span>
                <input type="text" name="mobile" [(ngModel)]="mobile" autocomplete="off" />
            </label>
            <label class="field">
                <span>{{ 'field_email' | translate }}</span>
                <input type="email" name="email" [(ngModel)]="email" autocomplete="off"
                    [class.invalid]="emailInvalid" [class.shake]="shaking && emailInvalid" />
            </label>
        </div>

        <div class="field">
            <span>{{ 'user_modal_categories' | translate }}</span>
            <ng-select
                class="tool-select"
                name="categoryIds"
                [items]="categories"
                bindLabel="categoryName"
                bindValue="id"
                [multiple]="true"
                [closeOnSelect]="false"
                [placeholder]="'user_modal_categories_placeholder' | translate"
                [(ngModel)]="categoryIds">
            </ng-select>
        </div>

        <div class="checkbox-group">
            <label class="checkbox-row">
                <input type="checkbox" name="active" [(ngModel)]="active" />
                <span>{{ 'field_active' | translate }}</span>
            </label>
            <label class="checkbox-row">
                <input type="checkbox" name="isAdmin" [(ngModel)]="isAdmin" />
                <span>{{ 'user_modal_admin' | translate }}</span>
            </label>
            <!-- Admins reach the dashboard anyway, so the box is redundant (and
                 disabled) while Admin is ticked. -->
            <label class="checkbox-row">
                <input type="checkbox" name="canAccessOrders" [(ngModel)]="canAccessOrders"
                    [disabled]="isAdmin" />
                <span class="stacked-label">
                    <span>{{ 'user_modal_orders_access' | translate }}</span>
                    <span class="hint">{{ (isAdmin ? 'user_modal_orders_hint_admin' : 'user_modal_orders_hint') | translate }}</span>
                </span>
            </label>
        </div>

        @if (error) {
            <p class="error">{{ error }}</p>
        }

        <button type="submit" class="user-modal__submit">{{ 'admin_action_save' | translate }}</button>
    </form>
</div>
